import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/logoHanoIT.svg";
import esriLogoVertical from "../../images/V_esriPartnerNet-Member_sRGBRev.png";
import esriLogoHorizontal from "../../images/H_esriPartnerNet-member_sRGBRev.png";


const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`
const Content = tw.div`max-w-full mx-auto py-10 px-8`;

const FooterWrapper = styled.div`
  ${tw`flex flex-col md:flex-row items-center md:items-start justify-center md:justify-between relative`}
`;

const CompanyInfoSection = tw.div`flex flex-col items-center justify-center flex-1`

const Row = tw.div`flex items-center justify-center flex-col`

const LogoContainer = tw.div`flex items-center justify-center`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-4 mb-2 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`

const Link = styled.a`
  ${tw`border-b-2 border-transparent pb-1 transition-all duration-300 mt-2 mx-4 text-gray-300`}
  position: relative;
  
  &:hover {
    color: #b52dd7;
    transform: translateY(-2px);
  }
  
  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -2px;
    left: 50%;
    background-color: #b52dd7;
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }
  
  &:hover::after {
    width: 100%;
  }
`;

const CopyrightText = tw.p`text-center mt-5 font-medium tracking-wide text-sm text-gray-600`

const EsriLogoContainer = styled.div`
  ${tw`mt-8 md:mt-0 flex items-center justify-center`}
  
  @media (min-width: 768px) {
    position: absolute;
    right: 2rem;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const EsriLogoImg = styled.img`
  ${tw`hidden md:block`}
  height: 150px;
  width: auto;
`;

const EsriLogoImgMobile = styled.img`
  ${tw`block md:hidden`}
  height: 60px;
  width: auto;
`;
export default () => {
  return (
    <Container>
      <Content>
        <FooterWrapper>
          <CompanyInfoSection>
            <Row>
              <LogoContainer>
                <LogoImg src={logo} />
                <LogoText>HanoIT</LogoText>
              </LogoContainer>
              <LinksContainer>
                <Link href="#main">Home</Link>
                <Link href="#our-services">Our Services</Link>
                <Link href="#our-portfolio">Our Portfolio</Link>
                <Link href="#our-expertise">Our Expertise</Link>
                <Link href="#contact-us">Contact Us</Link>
                <Link href="https://www.linkedin.com/company/hanoit/?viewAsMember=true" target="_blank" rel="noopener noreferrer">LinkedIn</Link>
              </LinksContainer>
              <CopyrightText>
              8883 WEST MCNAB ROAD STE 114 5N, TAMARAC, FL, 33321, US
                <br/>
                PBX:  <a href="tel:+17863533305">+1 786 353-3305</a>/<a href="tel:+16462622004">+1 646 262-2004</a>
                <br/>
                Email: <a href="mailto:admin@hanoit.com">admin@hanoit.com</a>
                <br/>
                &copy; Copyright 2020, Hanoit LLC. All Rights Reserved.
              </CopyrightText>
            </Row>
          </CompanyInfoSection>
          
          <EsriLogoContainer>
            <EsriLogoImg src={esriLogoVertical} alt="Esri Partner Network Member" />
            <EsriLogoImgMobile src={esriLogoHorizontal} alt="Esri Partner Network Member" />
          </EsriLogoContainer>
        </FooterWrapper>
      </Content>
    </Container>
  );
};
